import React, { Component } from "react";
import { withStyles } from '@material-ui/core/styles';
import { Comments } from 'react-facebook';

const styles = theme => ({ 

})

class VideoDetailComments extends Component {
  render() {
    const { classes } = this.props;
    return (
      <div style={{width: '100%', minHeight: 100, backgroundColor: '#CCC', marginTop: 12}}>
        <Comments colorScheme="dark" width="100%" href={`${process.env.BACKEND_URL}${this.props.asPath}`} />  
      </div>         
    );
  }

}

export default withStyles(styles)(VideoDetailComments);
